module.exports = __webpack_public_path__ + "img/1 (35).98e2b8fa.png";